export default "__VITE_ASSET__xx_XJrjY__"